import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';

function ShiftIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state
    const [name, setName] = useState("");
    const [punchInTime, setPunchInTime] = useState("");
    const [punchOutTime, setPunchOutTime] = useState("");

    const [isFocused, setIsFocused] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('ShiftApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching Shift:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    //handle search
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const SearchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleDelete = async () => {
        deleteData('ShiftApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ShiftApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addRecord = async (e) => {
        e.preventDefault();
        if (!name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        if (punchOutTime <= punchInTime) {
            alert("Punch Out Time must be after Punch In Time");
            return;
        }

        const formatTime = (time) => {
            if (!time) return null;
            const parts = time.split(':');
            if (parts.length === 2) {
                // If time is in HH:mm format — add seconds
                return `${time}:00`;
            } else if (parts.length === 3) {
                // Already in HH:mm:ss format — return as is
                return time;
            }
            return null; // fallback if format is unexpected
        };

        const workShift = {
            Name: name,
            PunchInTime: formatTime(punchInTime),
            PunchOutTime: formatTime(punchOutTime),
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('ShiftApi', workShift, token)
            .then((response) => {
                console.log('Shift Created success:', response);
                setSuccessMessage("Shift Created successfully!");
                setErrorMessage("");
                setName('');
                setIsModalOpen(false);
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Shift error:', error);
                setIsLoading(false);
            });
    };

    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    // const openDetailModal = async (id) => {
    //     try {
    //         const response = await fetchData('ShiftApi', `/ShiftDetails/${id}`, token);
    //         if (response.responseCode === '1111') {
    //             setUpdateData(response.response_data);
    //             setIsDetailModalOpen(true);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching Shift:', error);
    //     }
    // };

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('ShiftApi', `/ShiftDetails/${id}`, token);

            if (response.responseCode === '1111' && response.response_data) {
                const data = response.response_data;

                // 🕒 Convert "HH:mm:ss" to "HH:mm" for the input fields
                const formattedData = {
                    ...data,
                    PunchInTime: data.PunchInTime ? data.PunchInTime.slice(0, 5) : "",
                    PunchOutTime: data.PunchOutTime ? data.PunchOutTime.slice(0, 5) : "",
                };

                setUpdateData(formattedData);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Shift:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsLoading(false);
            return;
        }

        const formatTime = (time) => {
            if (!time) return null;
            const parts = time.split(':');
            if (parts.length === 2) {
                // If time is in HH:mm format — add seconds
                return `${time}:00`;
            } else if (parts.length === 3) {
                // Already in HH:mm:ss format — return as is
                return time;
            }
            return null; // fallback if format is unexpected
        };

        const workShift = {
            CompanyId: companyId,
            Id: updatedData.Id,
            Name: updatedData.Name,
            PunchInTime: formatTime(updatedData.PunchInTime),
            PunchOutTime: formatTime(updatedData.PunchOutTime),
            CreatedDate: updatedData.CreatedDate,
            CreatedBy: updatedData.CreatedBy,
            UpdatedBy: userId,
            UpdatedDate: new Date(),
        };

        try {
            await updateData('ShiftApi', `${updatedData.Id}`, workShift, token);

            // Reset form data
            setUpdateData({
                CompanyId: companyId,
                Name: '',
                PunchInTime: '',
                PunchOutTime: '',
            });

            setIsDetailModalOpen(false);
            fetchtableData(); // refresh table after update ✅
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 animate-zoomIn">
                    <div
                        className="border border-gray-400 shadow-lg rounded-lg overflow-hidden"
                        style={{
                            width: "600px",
                            backgroundColor: "#ffffff",
                            color: "#000000",
                            fontFamily: 'Cambria, "Times New Roman", serif',
                            height: "300px", // increased height
                        }}
                    >
                        {/* Header */}
                        <div
                            className="text-center py-1"
                            style={{
                                backgroundColor: "#13315c",
                                color: "#ffffff",
                                fontWeight: "bold",
                                fontSize: "14px",
                                letterSpacing: "0.5px",
                                marginTop: "-1px",
                            }}
                        >
                            Shift Create
                        </div>

                        {/* Inner Content */}
                        <div className="p-1">
                            <div className="border border-gray-300 p-3 rounded bg-white">
                                {/* Name Field */}
                                <div className="mb-4">
                                    <label
                                        htmlFor="Grpname"
                                        className="block text-xs uppercase font-semibold text-black mb-1"
                                    >
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Enter Name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        className="w-full border border-black px-3 py-2 text-sm rounded bg-white text-black placeholder-gray-600 focus:outline-none focus:border-[#13315c]"
                                        style={{
                                            fontFamily: 'Cambria, "Times New Roman", serif',
                                        }}
                                    />
                                </div>

                                {/* Time Fields */}
                                <div className="grid grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label
                                            htmlFor="punchInTime"
                                            className="block text-xs uppercase font-semibold text-black mb-1"
                                        >
                                            Punch In Time
                                        </label>
                                        <input
                                            type="time"
                                            name="punchInTime"
                                            value={punchInTime}
                                            onChange={(e) => setPunchInTime(e.target.value)}
                                            className="w-full border border-black px-3 py-2 text-sm rounded bg-white text-black focus:outline-none focus:border-[#13315c]"
                                            style={{
                                                fontFamily: 'Cambria, "Times New Roman", serif',
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label
                                            htmlFor="punchOutTime"
                                            className="block text-xs uppercase font-semibold text-black mb-1"
                                        >
                                            Punch Out Time
                                        </label>
                                        <input
                                            type="time"
                                            name="punchOutTime"
                                            value={punchOutTime}
                                            onChange={(e) => setPunchOutTime(e.target.value)}
                                            className="w-full border border-black px-3 py-2 text-sm rounded bg-white text-black focus:outline-none focus:border-[#13315c]"
                                            style={{
                                                fontFamily: 'Cambria, "Times New Roman", serif',
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex justify-end gap-2">
                                    <button
                                        className="px-4 py-2 text-sm font-semibold rounded transition"
                                        style={{
                                            backgroundColor: "#13315c",
                                            color: "#ffffff",
                                            border: "1px solid #0d2545",
                                            height: "31px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        onClick={addRecord}
                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0d2545")}
                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#13315c")}
                                    >
                                        Add Record
                                    </button>

                                    <button
                                        className="px-4 text-sm font-semibold rounded transition-colors duration-200"
                                        style={{
                                            backgroundColor: "#ffffff",
                                            color: "#ec743c",
                                            border: "1px solid #ec743c",
                                            height: "31px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        onClick={toggleModal}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#ec743c";
                                            e.currentTarget.style.color = "#ffffff";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "#ffffff";
                                            e.currentTarget.style.color = "#ec743c";
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <div style={{ marginTop: '-20px' }}>
                {/* Header Section */}
                <div className="flex flex-wrap justify-between items-center">
                    <h6 className="text-[#134B70] text-lg uppercase tracking-wide font-serif" style={{ fontSize: '14px' }}>
                        Shift
                    </h6>
                    <Tooltip title="Create Shift" arrow>
                        <Button
                            className="linkcolor"
                            component={Link}
                            to="/EmployeeCreate"
                            variant="contained"
                            sx={{
                                backgroundColor: "#134B70",
                                textTransform: "none",
                                borderRadius: "20px",
                                fontSize: "12px",
                                padding: "4px 18px",
                                "&:hover": { backgroundColor: "#0d3b66" },
                            }}
                        >
                            + Create
                        </Button>
                    </Tooltip>
                </div>

                {/* Responsive Table Section */}
                <div className="rounded-lg border border-gray-300" style={{ marginTop: '10px' }}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            boxShadow: "none",
                            maxHeight: 490, // <== height should be set here
                            overflow: "auto",
                            borderRadius: "8px",
                        }}
                    >
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {["Sl.No", "Name", ""].map((col, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                background: "linear-gradient(to right, #0D1B2A, #1B2A41)",
                                                color: "white",
                                                fontWeight: 700,
                                                fontSize: 11,
                                                textTransform: "uppercase",
                                                padding: "2px 4px",
                                                borderBottom: "2px solid #0D1B2A",
                                                textAlign: col === "" ? "right" : "left",
                                            }}
                                        >
                                            {col}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.map((item, index) => (
                                    <TableRow
                                        key={item.Id}
                                        sx={{
                                            "&:hover": { backgroundColor: "#f9fafc" },
                                            transition: "0.2s ease-in-out",
                                        }}
                                    >
                                        <TableCell sx={{ fontSize: "12px", padding: "3px" }}>{index + 1}</TableCell>
                                        <TableCell sx={{ fontSize: "12px", padding: "3px" }}>{item.Name}</TableCell>
                                        <TableCell align="right" sx={{ fontSize: "12px", padding: "3px" }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip title="Edit Shift" arrow>
                                                    <IconButton onClick={() => openDetailModal(item.Id)}>
                                                        <EditIcon style={{ color: "blueviolet", fontSize: "19px" }} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {/* Footer */}
                <div className="text-center text-gray-500 text-xs mt-3">
                    <CopyrightIcon sx={{ fontSize: 12, verticalAlign: "middle", mr: 0.5 }} />
                    <b style={{ fontFamily: "Georgia, serif" }}>EFFTABS SOLUTIONS LLP</b>
                </div>
            </div>

            {isDetailModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 animate-zoomIn">
                    <div
                        className="border border-gray-400 shadow-lg rounded-lg overflow-hidden"
                        style={{
                            width: "600px",
                            backgroundColor: "#ffffff", // body is white
                            color: "#000000",
                            fontFamily: 'Cambria, "Times New Roman", serif',
                            height: "300px", // increased height for better layout
                        }}
                    >
                        {/* Header */}
                        <div
                            className="text-center py-1"
                            style={{
                                backgroundColor: "#0d4f5f", // deep blue header
                                color: "#ffffff",
                                fontWeight: "bold",
                                fontSize: "14px",
                                letterSpacing: "0.5px",
                                marginTop: "-1px",
                            }}
                        >
                            Shift Edit
                        </div>

                        {/* Inner Content */}
                        <div className="p-1">
                            <div className="border border-gray-300 p-3 rounded bg-white">

                                {/* Name Field */}
                                <div className="mb-4">
                                    <label
                                        htmlFor="Grpname"
                                        className="block text-xs uppercase font-semibold text-black mb-1"
                                    >
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        name="Name"
                                        placeholder="Enter Name"
                                        value={updatedData.Name || ""}
                                        onChange={handleUpdateInputChange}
                                        className="w-full border border-black px-3 py-2 text-sm rounded bg-white text-black placeholder-gray-600 focus:outline-none focus:border-[#13315c]"
                                        style={{
                                            fontFamily: 'Cambria, "Times New Roman", serif',
                                        }}
                                    />
                                </div>

                                {/* Time Fields */}
                                <div className="grid grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label
                                            htmlFor="PunchInTime"
                                            className="block text-xs uppercase font-semibold text-black mb-1"
                                        >
                                            Punch In Time
                                        </label>
                                        <input
                                            type="time"
                                            name="PunchInTime"
                                            value={updatedData.PunchInTime || ""}
                                            onChange={handleUpdateInputChange}
                                            className="w-full border border-black px-3 py-2 text-sm rounded bg-white text-black focus:outline-none focus:border-[#13315c]"
                                            style={{
                                                fontFamily: 'Cambria, "Times New Roman", serif',
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label
                                            htmlFor="PunchOutTime"
                                            className="block text-xs uppercase font-semibold text-black mb-1"
                                        >
                                            Punch Out Time
                                        </label>
                                        <input
                                            type="time"
                                            name="PunchOutTime"
                                            value={updatedData.PunchOutTime || ""}
                                            onChange={handleUpdateInputChange}
                                            className="w-full border border-black px-3 py-2 text-sm rounded bg-white text-black focus:outline-none focus:border-[#13315c]"
                                            style={{
                                                fontFamily: 'Cambria, "Times New Roman", serif',
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex justify-end gap-2">
                                    {/* Update Record Button */}
                                    <button
                                        className="px-4 py-2 text-sm font-semibold rounded transition"
                                        style={{
                                            backgroundColor: "#0d4f5f", // deep blue
                                            color: "#ffffff",
                                            border: "1px solid #0d4f5f",
                                            height: "31px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        onClick={updateRecord}
                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0b3f4c")}
                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0d4f5f")}
                                    >
                                        Update Record
                                    </button>

                                    {/* Cancel Button */}
                                    <button
                                        className="px-4 text-sm font-semibold rounded transition-colors duration-200"
                                        style={{
                                            backgroundColor: "#ffffff",
                                            color: "#d3240d",
                                            border: "1px solid #d3240d",
                                            height: "31px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        onClick={toggleModalBranch}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#d3240d";
                                            e.currentTarget.style.color = "#ffffff";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "#ffffff";
                                            e.currentTarget.style.color = "#d3240d";
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>

    );
}

export default ShiftIndex;
